export default {
  'hideItemMoves': "This hides all custom item moves from the Cancel Info list. This makes the list a lot less cluttered, but this option is here in case you want to see them",
  'hideBackSideMoves': "This hides all back and side turned moves from the Cancel Info list. This makes the list a lot less cluttered, but this option is here in case you want to see them",
  'cancelInfo':"This area shows all the different ways this character can transition from this state. This includes attacks, options like movement, and events like being blocked, landing a hit, or even...dying!"
}



// WEBPACK FOOTER //
// ./src/tooltips.js